<script>
import fadeInUp from '../components/animations/FadeInUp.vue';
import linesUp from '../components/animations/LinesUp.vue';
import magnetic from '../components/Magnetic.vue';
import wordsUp from '../components/animations/WordsUp.vue';
import zoomIn from '../components/animations/ZoomIn.vue';

export default {
    components: {
        fadeInUp,
        linesUp,
        magnetic,
        wordsUp,
        zoomIn
    },

    mounted() {
        this.parallax();
    },

    methods: {
        parallax() {
            const parallax = gsap.timeline({
                scrollTrigger: {
                    trigger: this.$refs.container,
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true
                }
            });

            parallax.add('start').fromTo(
                this.$refs.background,
                {
                    yPercent: 0,
                    scale: 1
                },
                {
                    yPercent: 40,
                    scale: 1.1,
                    ease: 'none'
                }
            );

            if (this.$refs.content) {
                parallax.fromTo(
                    this.$refs.content,
                    {
                        yPercent: 0,
                        opacity: 1,
                        scale: 1
                    },
                    {
                        yPercent: -200,
                        opacity: 0,
                        scale: 1.25,
                        ease: 'none'
                    },
                    'start'
                );
            }
        }
    }
};
</script>
